<script>
import List from '@/components/List/List.vue'
import Form from '@/components/Form/Form.vue'
import PopUp from '@/components/PopUp.vue'
import ToAdmin from '@/components/ToAdmin.vue'
import UserInstruction from '@/components/UserInstruction.vue'
import message from '@/helpers/message'
export default {
    components:{ List, Form, PopUp, ToAdmin, UserInstruction },
    created() {  
        if(this.user.user_level != 'SamfallifyCrew' && this.user.user_level != 'Redaktör')
        {
            this.$router.push('/login');
        }        
        this.$cache.createCache('adminOpenApplication', 'admin-open-application/');
        this.$cache.createCache('accountSettings', 'account-settings/') 
    },
    data() {
        return {               
            sorting: [
                { name: 'created_date', displayName: 'Skapad' },           
                { name: 'created_by_full_name', displayName: 'Skapad Av' },           
            ],
            editItem: null,
            
        }
    },   
    methods:
    {
        edit(item)
        {
            this.editItem = item;
        },
        add()
        {
            this.editItem = { id: 0, description: '', include_in_public_site: false, image_id: null };
        },
        delete(id)
        {
            var self = this;
            this.$communicator.post('admin-open-application/' + id + '/delete')
                .then(function(data)
                {                 
                    self.getApplications();
                    message.setSuccessMessage();
                })
                .fail(function(error) {                  
                })  
        },
        getApplications()
        {
            this.editItem = null;
            this.$cache.updateCache('adminOpenApplication', 'admin-open-application/');
        }
    },
    computed:
    {
        user() {return this.$store.state.user; },
        accountSettings() {return this.$store.state.accountSettings; },
        news() {   return this.$store.state.adminNews != undefined ? this.$store.state.adminNews : [] },
        applications() {  return this.$store.state.adminOpenApplication != undefined ? this.$store.state.adminOpenApplication : [] },
        columns() { 
            var cols = [                             
                { name: 'edit', displayName: '<i class="fa-solid fa-pen color-black"></i>', title: 'Redigera', icon: 'fa-solid fa-pencil', align:'center', function: this.edit, width: 25, hideFilter: true, hideIfEdit: true},
                { name: 'delete', displayName: '<i class="fa-solid fa-trash color-black"></i>', title: 'Ta bort', isDelete: true, align:'center', width: 25, hideFilter: true, hideIfEdit: true},
                { name: 'title', displayName: 'Titel', width: 300, hideFilter: true, isTextEditorFormat: true},             
                { name: 'formatted_created_date', displayName: 'Skapad', width: 100, hideFilter: true},
                { name: 'created_by_full_name', displayName: 'Skapad Av', width: 200},
                { name: 'description', displayName: 'Beskrivning', width: 1400, hideFilter: true, isTextEditorFormat: true},             
            ] 

            if(this.$store.state.accountSettings != null && this.$store.state.accountSettings.enable_public_page)
            {
                cols.splice(3,0,{ name: 'include_in_public_site', isBoolean: true, displayName: '<i class="fa-solid fa-globe color-black"></i>', align:'center',excelName:'Visas även på den publika sidan', title:'Visas även på den publika sidan', width: 30 });
            }
            return cols;
        },        
        form() {
            var form = [                   
                { sections: [
                    { sectionName: 'Lägg till ' + this.$store.state.settings.OpenApplication.plural, classes: "g-50", inputs: [
                        { type: 'text', prop: 'title', title: 'Titel', classes: "g-100", required: true },                        
                        { type: 'textEditor', prop: 'description', title: 'Beskrivning', classes: "g-100", required: true },                        
                        ]
                    },
                    { sectionName: 'Lägg till bild', classes: "g-50", inputs: [
                        { type: 'image', prop: 'image_id', title: 'Klicka på den bild du vill visa', classes: "g-100" },                        
                        ]
                    }
                    ]
                }];
            
            if(this.$store.state.accountSettings != null && this.$store.state.accountSettings.enable_public_page)
            {
                form[0].sections[0].inputs.push({ type: 'switch', prop: 'include_in_public_site', title: 'Visa även intresseanmälan på den publika sidan', classes: "g-100" });
            }

            return form;
        }
    }
}
</script>
<template>
    <div v-fade-in>
        <main class="opacity-admin-bg overflow-auto position-relative" v-if="accountSettings != null">
            <div class="float-right">
                <button id="List-sort-btn" class="btn" @click="add">Lägg till {{this.$store.state.settings.OpenApplication.singular}}</button>
                <UserInstruction :page="this.$route.name"></UserInstruction>
            </div>
            <ToAdmin :section="this.$store.state.settings.OpenApplication.plural"></ToAdmin>
            <h2>{{this.$store.state.settings.OpenApplication.plural}}</h2>
                <div v-if="editItem != null">
                    <PopUp>
                    <Form :form="form" :item="editItem" :url="'admin-open-application/'" :getItemFunction="getApplications" :inEditMode="true"></Form>
                    </PopUp>
                </div>
            <List v-if="applications.length > 0" :items="applications"
                :columns="columns" 
                :noOfFrozenColumns="3" 
                :deleteFunction="delete" 
                :isEditing="editItem != null" 
                :nameOfItems="this.$store.state.settings.OpenApplication.plural" 
                :sorting="sorting" 
                :backgroundColor="this.$colors.list.backgroundColor" 
                :borderColor="this.$colors.list.borderColor">
             </List>        
            <div v-else> Du har inte lagt upp några {{this.$store.state.settings.OpenApplication.plural}}</div>
        </main>
    </div>
</template>
<style scoped>

</style>